const ressourcesTypes = {
  video: { icon: 'Play', color: '#EF5350' },
  audio: { icon: 'EyeOff', color: '#9575CD' },
  lien: { icon: 'Link', color: '#4FC3F7' },
  padlet: { icon: 'LabelTag', color: '#FF8A65' },
  quizlet: { icon: 'Calendar', color: '#FFCC80' },
  texte: { icon: 'Edit', color: '#90A4AE' },
  tableur: { icon: 'Ranking', color: '#A1887F' },
  image: { icon: 'Landscape', color: '#81D4FA' },
  genially: { icon: 'Graduate', color: '#81C784' }
};

export const getRessourceTypeInfo = (type: string) => {
  return ressourcesTypes[type] || { icon: 'Link', color: 'gray' };
};
